import "./newStaff.css";
import { useState } from 'react';
import { useRegisterStaffMutation } from '../../services/userCRUDApi'
import { useNavigate } from "react-router-dom";
import { AdminPageHeader, AdminCard, AdminInput, AdminSelect, LoadingButton, useToast } from '../../components/ui'

const NewStaff = () => {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({})
  const [registerUser, { isLoading }] = useRegisterStaffMutation()
  const toast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const actualData = {
      first_Name: data.get("first_Name"),
      last_Name: data.get("last_Name"),
      email: data.get("email"),
      password: data.get("password"),
      type: data.get("type"),
      phone_Number: data.get("phone_Number"),
      address: {
        house_Number: data.get("house_Number"),
        street_Number: data.get("street_Number"),
        city: data.get("city"),
        area: data.get("area")
      }
    };

    const res = await registerUser(actualData);
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not create this staff account. Check the fields below.");
    }
    if (res.data) {
      toast.success("Staff account created successfully.");
      setTimeout(() => navigate('/admin/staff'), 1200);
    }
  };

  return (
    <div>
      <AdminPageHeader
        title="Create Staff Account"
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Staff", to: "/admin/staff" }, { label: "New" }]}
      />
      <AdminCard className="newStaffForm">
        <form onSubmit={handleSubmit}>
          <div className="newStaffForm__row">
            <AdminInput label="First Name" placeholder="Enter first name" name="first_Name" error={server_error.first_Name?.[0]} required />
            <AdminInput label="Last Name" placeholder="Enter last name" name="last_Name" error={server_error.last_Name?.[0]} required />
          </div>
          <AdminInput label="Email" type="email" placeholder="Enter email address" name="email" error={server_error.email?.[0]} required />
          <AdminInput label="Password" type="password" placeholder="Enter password" name="password" error={server_error.password?.[0]} required />
          <div className="newStaffForm__row">
            <AdminInput label="Phone Number" placeholder="98xxxxxxxx" name="phone_Number" error={server_error.phone_Number?.[0]} required />
            <AdminSelect label="User Type" name="type">
              <option value="STAFF">Staff</option>
              <option value="DELIVER_BOY">Delivery Boy</option>
            </AdminSelect>
          </div>
          <div className="newStaffForm__row">
            <AdminInput label="House Number" placeholder="Enter house number" name="house_Number" error={server_error.house_Number?.[0]} />
            <AdminInput label="Street Number" placeholder="Enter street number" name="street_Number" error={server_error.street_Number?.[0]} />
          </div>
          <div className="newStaffForm__row">
            <AdminInput label="Area" placeholder="Enter area/phase" name="area" error={server_error.area?.[0]} />
            <AdminSelect label="City" name="city">
              <option value="Chennai">Chennai</option>
              <option value="Coimbatore">Coimbatore</option>
            </AdminSelect>
          </div>
          <div className="newStaffForm__actions">
            <LoadingButton type="submit" loading={isLoading} loadingLabel="Creating...">Create Staff</LoadingButton>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default NewStaff
